import { v4 as uuidv4 } from "uuid";

import {
  getContrast,
  getFormattedPrice,
  isProductDataWithOptions,
} from "../utils";

export class ProductService {
  constructor(data) {
    this.data = data;
  }

  get dataWithOptions() {
    return isProductDataWithOptions(this.data);
  }

  static getContrastColor(selectedColor) {
    return (
      getContrast(selectedColor && selectedColor.hex) || {
        label: "hvid",
        hex: "#ffffff",
      }
    );
  }

  static getFormattedTotalPrice = (data, showVAT) => {
    return getFormattedPrice(
      (showVAT ? data.item.price : data.item.priceNoVat) * data.qty
    );
  };

  static getInitLinesValues = (data) => {
    if (data) return data;
    return {
      line1Part1: "",
      line1Part2: "",
      line2Part1: "",
      line2Part2: "",
    };
  };

  getDefaultSelectedColor() {
    if (this.data.options && this.data.options.skilt_farve) {
      const hexDefault = this.data.options.skilt_farve.default;
      const defaultColorOption = this.data.options.skilt_farve.values.find(
        (item) => item.value === hexDefault
      );
      if (defaultColorOption) {
        return {
          label: defaultColorOption.label,
          hex: defaultColorOption.value,
        };
      }
    }
    return null;
  }

  getColors = () => {
    return (
      (this.data.options.skilt_farve &&
        this.data.options.skilt_farve.values &&
        this.data.options.skilt_farve.values.map((item) => ({
          hex: item.value,
          label: item.label,
        }))) ||
      []
    );
  };

  prepareProductData(
    qty,
    _selectedColor,
    lines = ProductService.getInitLinesValues()
  ) {
    const options = {};
    const selectedColor = _selectedColor || this.getDefaultSelectedColor();
    const contrastColor = ProductService.getContrastColor(selectedColor);

    // Set options
    if (this.dataWithOptions) {
      options["skilt_farve"] = selectedColor.hex;
      options["skilt_skrift_farve"] = contrastColor.hex;
      options["tekst_1-1"] = lines.line1Part1;
      options["tekst_1-2"] = lines.line1Part2;
      options["tekst_2-1"] = lines.line2Part1;
      options["tekst_2-2"] = lines.line2Part2;
    }

    // do not store html in LS to prevent from using it with dangerouslyInsertHTML to avoid XSS attacks
    const { description_html, ...restItem } = this.data;

    const item = {
      id: uuidv4(),
      lines: this.dataWithOptions ? lines : undefined,
      qty,
      item: restItem,
      options: options,
      bgColor: this.dataWithOptions ? selectedColor : undefined,
      textColor: this.dataWithOptions ? contrastColor : undefined,
    };

    return item;
  }
}
